/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { IMapContextMenuPermissions, GeofenceMarkerInfo, LatLng, IMapContextMenuData } from '../../../core/models';

@Component({
  selector: 'fm-geofence-menu-container',
  templateUrl: './geofence-menu-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeofenceMenuContainerComponent {
  @Input()
  public menuData: IMapContextMenuData<GeofenceMarkerInfo>;

  @Input()
  public userPermissions: IMapContextMenuPermissions;

  @Output()
  public closed: EventEmitter<void> = new EventEmitter();

  @Output()
  public findNearestClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public zoomToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public streetViewClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public editPlaceClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionToClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public getDirectionFromClicked: EventEmitter<void> = new EventEmitter();

  @Output()
  public locationToGarminClicked: EventEmitter<LatLng> = new EventEmitter();

  @Output()
  public copyCoordinatesClicked: EventEmitter<string> = new EventEmitter();

  public onMenuClosed(): void {
    this.closed.emit();
  }

  public onFindNearestClicked(): void {
    this.findNearestClicked.emit();
  }

  public onZoomToClicked(): void {
    this.zoomToClicked.emit();
  }

  public onStreetViewClicked(): void {
    this.streetViewClicked.emit();
  }

  public onEditPlaceClicked(): void {
    this.editPlaceClicked.emit();
  }

  public onGetDirectionToClicked(): void {
    this.getDirectionToClicked.emit();
  }

  public onGetDirectionFromClicked(): void {
    this.getDirectionFromClicked.emit();
  }

  public onLocationToGarminClicked(): void {
    this.locationToGarminClicked.emit(this.menuData.clickLatLng);
  }

  public onCopyCoordinates(coordinatesToCopy: string): void {
    this.copyCoordinatesClicked.emit(coordinatesToCopy);
  }
}
